package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SupportTicketStatisticsResponse(
    @SerialName("total") val total: Int? = null,
    @SerialName("open") val open: Int? = null,
    @SerialName("in_progress") val inProgress: Int? = null,
    @SerialName("resolved") val resolved: Int? = null,
    @SerialName("closed") val closed: Int? = null
)

@Serializable
data class TicketListItemResponse(
    @SerialName("id") val id: String? = null,
    @SerialName("ticket_id") val ticketId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("school_name") val schoolName: String? = null,
    @SerialName("requester_id") val requesterId: String? = null,
    @SerialName("requester_name") val requesterName: String? = null,
    @SerialName("requester_role") val requesterRole: String? = null,
    @SerialName("subject") val subject: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("assigned_to_id") val assignedToId: String? = null,
    @SerialName("assigned_to_name") val assignedToName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("last_message_at") val lastMessageAt: String? = null,
    @SerialName("message_count") val messageCount: Int? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null
)

@Serializable
data class TicketResponse(
    @SerialName("id") val id: String? = null,
    @SerialName("ticket_id") val ticketId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("school_name") val schoolName: String? = null,
    @SerialName("requester_id") val requesterId: String? = null,
    @SerialName("requester_name") val requesterName: String? = null,
    @SerialName("requester_role") val requesterRole: String? = null,
    @SerialName("subject") val subject: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("category") val category: String? = null,
    @SerialName("assigned_to_id") val assignedToId: String? = null,
    @SerialName("assigned_to_name") val assignedToName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("messages") val messages: List<TicketMessageResponse>? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String>? = null
)

@Serializable
data class TicketMessageResponse(
    @SerialName("id") val id: String? = null,
    @SerialName("ticket_id") val ticketId: String? = null,
    @SerialName("sender_id") val senderId: String? = null,
    @SerialName("sender_name") val senderName: String? = null,
    @SerialName("sender_type") val senderType: String? = null,
    @SerialName("message") val message: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String>? = null
)
